module.exports = __webpack_public_path__ + "dist/img/voyager.9d17895.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/voyager.svg
// module id = NSdT
// module chunks = 1